<template>
  <div class="polis">
    <div class="area">
      <h3>请选择您的城市</h3>
      <!--<area-select :level="1" type="text" v-model="selected" :data="pca"></area-select>-->
      <div class="cityName">
        <span>城市：</span>
        <div class="citySelect">
          <area-city @city="city" />
        </div>
      </div>
      <i class="iconfont icon-guanbi icon" @click="handleClick"></i>
      <button @click="handleClick">确定</button>

    </div>
  </div>

</template>

<script>
import AreaCity from './AreaCity'
export default {
  data() {
    return{
      cityinfo: ''
    }
  },
  methods: {
    handleClick () {
      this.$emit('showCity')
      this.$emit('cityinfo', this.cityinfo)
    },
    city(data) {
      this.cityinfo = data[1]
    }
  },
  components: {
    AreaCity
  }
}
</script>

<style scoped lang="less" type="text/less">
  .polis{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index:1000;
    background: rgba(0,0,0,.5);
    .area{
      position: relative;
      width: 500px;
      height: 200px;
      margin:100px auto;
      padding:30px 20px;
      background: #fff;
      border-radius: 5px;
      h3{
        padding-bottom: 20px;
        font-size: 20px;
        font-weight: bold;
        border-bottom: 1px solid #e1e1e1;
      }
      .cityName{
        display: flex;
        margin-top:20px;
        align-items: center;
        span{
          margin-right: 10px;
        }

      }
      button{
        display: block;
        margin:40px auto 0;
        width: 150px;
        height: 40px;
        font-size: 16px;
        border:1px solid #e1e1e1;
        background: #fff;
        border-radius: 5px;
        cursor: pointer;
      }
      .icon{
        position: absolute;
        top: 10px;
        right: 20px;
        font-size: 18px;
        cursor: pointer;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Area.vue